export class BaseLanguage {
  //#################################################################################
  //
  // This service holds hashmap containing all german strings used in our platform
  // When translating, please keep keys (first argument) same, while
  // adapting the values (seconds argument).
  //
  // This is the base class that all languages must derive from. No translations
  // are done in this class.
  //
  //#################################################################################

  private lang = new Map<string, string>();

  /**
   * Populate hashmap with key-value pairs for the given language. Keys will be same in all languages
   * @param key The identifier for a translation. Must be the same in all languages.
   * @param value The translation that the key corresponds to
   */
  define(key: string, value: string) {
    this.lang[key] = value;
  }

  getLang() {
    return this.lang;
  }
}



// WEBPACK FOOTER //
// ./src/app/languages/baseLang.service.ts